import ImgCrop, { ImgCropProps } from 'antd-img-crop'

interface ImageCropProps extends ImgCropProps {}

export const ImageCrop = (props: ImageCropProps): JSX.Element => (
  <>
    <ImgCrop {...props} children={props.children} />
  </>
)
